import React from 'react';
import { Skeleton } from "../index";

import {
  ReviewContainer,
  ReviewHeaderWrapper,
} from './styles';

const ReviewGhost = () => (
  <ReviewContainer>
    <ReviewHeaderWrapper>
      <Skeleton height={18} width={100} />
      <Skeleton height={15} width={100} />
    </ReviewHeaderWrapper>
    <Skeleton height={40} width="100%" />
  </ReviewContainer>
);

export default ReviewGhost;
